module.exports = __webpack_public_path__ + "static/media/ramen.bdfc8c00.png";